import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
type State = {
  IdProjeto: number;
  Informacoes: string;
  Data: Date | null;
};

type Actions = {
  setInformacoes: SetFunction<string>;
  setData: SetFunction<Date>;
  setIdProjeto: SetFunction<number>;
};

export const initialInformacoesFiltersState: State = {
  IdProjeto: 0,
  Informacoes: "",
  Data: null,
};

export const useFiltersInformacoes = create<State & Actions>((set) => ({
  ...initialInformacoesFiltersState,
  setIdProjeto: (vfn) => SetFunctionImpl(set, 'IdProjeto', vfn),
  setInformacoes: (vfn) => SetFunctionImpl(set, 'Informacoes', vfn),
  setData: (vfn) => SetFunctionImpl(set, 'Data', vfn),
}));
